import { IInsuredsDetails } from '../types';

const roundTo3 = (value: number) => Math.round(value * 1000) / 1000;

export const recalculateInsuredPolicyMedicalVariances = (
  row: IInsuredsDetails
): Pick<
  IInsuredsDetails,
  | 'grossPremiumVariance'
  | 'coverProportionalStamp'
  | 'coverMunicipalityTax'
  | 'totalPremiumVariance'
> => {
  const grossPremiumVariance =
    Number(row.netPremiumVariance ?? 0) +
    Number(row.chargesVariance ?? 0) +
    Number(row.tpaFeesVariance ?? 0);

  const coverProportionalStamp = roundTo3(
    Number(row.proportionalStampRate ?? 0) * grossPremiumVariance
  );
  const coverMunicipalityTax = roundTo3(
    Number(row.municipalityTaxRate ?? 0) * grossPremiumVariance
  );
  const totalPremiumVariance =
    grossPremiumVariance + coverProportionalStamp + coverMunicipalityTax;

  return {
    grossPremiumVariance,
    coverProportionalStamp,
    coverMunicipalityTax,
    totalPremiumVariance
  };
};
